import React, { useState} from 'react';
import { Card, Form, Button, Row, Col, Container,Alert,Spinner } from 'react-bootstrap';
import { useNavigate, useSearchParams,useLocation } from 'react-router-dom';
import { postData, postDataLogin } from '../ApiServices/ApiService';
import javaImg from './../assets/icons/java.png';
import reactImg from './../assets/icons/reactjs/reactjs.svg';
import sqlImg from './../assets/icons/mysql/mysql.svg';
import htmlImg from './../assets/icons/html/html.svg';
import cssImg from './../assets/icons/css/css.svg';
import angularImg from './../assets/icons/angular/angular.svg';
import awsImg from './../assets/icons/aws/aws.svg';
import restImg from './../assets/icons/rest-api/rest-api.svg';
import springImg from './../assets/icons/spring/spring.svg';
import pythonImg from './../assets/icons/python/python.svg';
import NavHeader from './NavHeader';


const TechSelect = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const job_id = searchParams.get('id');
  const company_id = searchParams.get('cid')
  const updateState = location.state?.update || 0;

  const [experienceLevel, setExperienceLevel] = useState('Intermediate');
  const [selectedTechnologies, setSelectedTechnologies] = useState([]);
  // const experienceLevels = ['Beginner', 'Intermediate', 'Experienced'];
  // const [inputValue, setinputValue] = useState('');

  const technologies = [
    { name: "Java", src: javaImg, short: "A versatile language for cross-platform applications." },
    { name: "React", src: reactImg, short: "A library for building dynamic web user interfaces." },
    { name: "SQL", src: sqlImg, short: "Language for managing and querying relational databases." },
    { name: "HTML", src: htmlImg, short: "The standard markup language for web pages." },
    { name: "CSS", src: cssImg, short: "Stylesheet language for designing web page layouts." },
    { name: "Angular", src: angularImg, short: "A framework for building scalable web applications." },
    { name: "AWS", src: awsImg, short: "A comprehensive cloud platform for diverse services." },
    { name: "REST Api", src: restImg, short: "Architectural style for networked applications." },
    { name: "Springboot", src: springImg, short: "A framework for easy Java-based applications development." },
    { name: "Python", src: pythonImg, short: "A language known for simplicity and versatility." }
   
  ];

  // const handleExperienceChange = (level) => {
  //   setExperienceLevel(level);
  // };

  const handleTechnologyChange = (technology) => {
    const isSelected = selectedTechnologies.includes(technology);

    if (isSelected) {
      setSelectedTechnologies((prevTechnologies) =>
        prevTechnologies.filter((tech) => tech !== technology)
      );
    } else {
      setSelectedTechnologies((prevTechnologies) => [
        ...prevTechnologies,
        technology,
      ]);
    }
  };

  const handleSubmit =  async (e) => {
    
    e.preventDefault();
    const aminInfo = JSON.parse(localStorage.getItem('ai-admin'));
   
    if(selectedTechnologies.length <= 0){
      setError('Please Select Technologies');
      return
    }
    if(selectedTechnologies.length > 10){
      setError('Please Select Technologies Less Than Or Equal To 10');
      return
    }
    // const isAnyInvalidTechnology = selectedTechnologies.some((techName) => {
    //   const matchingTech = technologies.find((tech) => tech.name.toLowerCase() === techName.toLowerCase());
    //   return !matchingTech;
    // });
  
    // if (isAnyInvalidTechnology) {
    //   setError('Invalid Technology entered');
    //   return;
    // }
    // Add your submission logic here
    var techJson = {};
    selectedTechnologies.forEach(element => {
      
      techJson[element] = element;
    });
    if(updateState === "1"){
      const payload = {
        "op":"update_tech_q",
        "company_id": company_id,
        "user_id": aminInfo.user_id,
        "technologies": techJson,
        "job_id":job_id
      }
      
      // return
      setLoading(true);
      setError('');
      try {
        await postData('admin_in/job/update-job-details',payload).then(resp => {
          resp.json().then(respData => {
            if (resp.status === 200) {
          if(respData.statusCode === 200){
            if(respData.message.toLowerCase() === 'success'){
              setLoading(false);
              // setError(resp.info);
              //const queryParams = { c_id: 'can-qwer-45555' };
              //navigate(`/selected-technologies?${new URLSearchParams(queryParams)}`);
              navigate(`/link-generator?id=${job_id}&cid=${company_id}`,{ state: { selectedTechnologies: selectedTechnologies,updateState:"1" } });
              // navigate(path, );
  
               // Navigate to the next page with selected technologies
             // history.push('/selected-technologies', { selectedTechnologies });
            }else{
              setLoading(false);
              setError(respData.info); 
            }
         
          }else if(resp.statusCode === 500){
            setLoading(false);
              setError(respData.info);        
          }else{
            setLoading(false);
            setError('Error While Getting Techonologies');
          }
        }
        else if (resp.status === 401 || resp.status === 403 || resp.status === 400) {
          console.log('resp status else if : ', resp.status);
          if (respData.message === 'Unauthorized' || respData.message === 'The incoming token has expired'
            || respData.message === 'Access Denied') {
              setLoading(false);
            //   callRefreshTokenApi('getSfeBatch', '');
          }
          setError('Looks Like Session Expired Please login..');
        }else {
          console.log('resp status else  : ', resp);
          setLoading(false);
        }
      }).catch((error) => {
        setError('Network Error');
        console.log('network error:', error);
        setLoading(false);
      });
        }).catch((error) => {
          setLoading(false);
          setError('Techonologies failed. Please check your credentials or Network Error');
          console.log('network error:', error);
        });
      } catch (error) {
        setLoading(false);
        // Handle login error, e.g., display an error message to the user.
        console.error('Techonologies failed', error);
      }

    }else{
      const payload = {
        "op":"register_ai_question",
        "company_id": company_id,
        "user_id": aminInfo.user_id,
        "technologies": techJson,
        "job_id":job_id
      }
      
      // return
      setLoading(true);
      setError('');
      try {
        await postData('/admin_in/test_input_one',payload).then(resp => {
          resp.json().then(respData => {
            if (resp.status === 200) {
          if(respData.statusCode === 200){
            if(respData.message.toLowerCase() === 'success'){
              setLoading(false);
              // setError(resp.info);
              //const queryParams = { c_id: 'can-qwer-45555' };
              //navigate(`/selected-technologies?${new URLSearchParams(queryParams)}`);
              navigate(`/link-generator?id=${job_id}&cid=${company_id}`,{ state: { selectedTechnologies: selectedTechnologies } });
              // navigate(path, );
  
               // Navigate to the next page with selected technologies
             // history.push('/selected-technologies', { selectedTechnologies });
            }else{
              setLoading(false);
              setError(respData.info); 
            }
         
          }else if(resp.statusCode === 500){
            setLoading(false);
              setError(respData.info);        
          }else{
            setLoading(false);
            setError('Error While Getting Techonologies');
          }
        }
        else if (resp.status === 401 || resp.status === 403 || resp.status === 400) {
          console.log('resp status else if : ', resp.status);
          if (respData.message === 'Unauthorized' || respData.message === 'The incoming token has expired'
            || respData.message === 'Access Denied') {
              setLoading(false);
            //   callRefreshTokenApi('getSfeBatch', '');
          }
          setError('Looks Like Session Expired Please login..');
        }else {
          console.log('resp status else  : ', resp);
          setLoading(false);
        }
      }).catch((error) => {
        setError('Network Error');
        console.log('network error:', error);
        setLoading(false);
      });
        }).catch((error) => {
          setLoading(false);
          setError('Techonologies failed. Please check your credentials or Network Error');
          console.log('network error:', error);
        });
      } catch (error) {
        setLoading(false);
        // Handle login error, e.g., display an error message to the user.
        console.error('Techonologies failed', error);
      }
    }
    
   
  };

  // const handleInputTechnologyChange = (e) => {
  //   const { value } = e.target;
  //   setSelectedTechnologies(value.split(',').map((tech) => tech.trim()));
  // };
  const handleInputTechnologyChange = (e) => {
    const { value } = e.target;
    if (value === '') {
      setSelectedTechnologies([]);
    } else {
      setSelectedTechnologies(value.split(',').map((tech) => tech.trim()));
    }
  };

  return (
    <div className='dashboard-div '>
    <NavHeader></NavHeader>
    
    <div className='tech-div '>
    <h2 className='cand-title' style={{paddingTop:'25px'}}>Select Technologies</h2>
      <Container className="tech-details-div ">
      {error && <Alert variant="danger" className='error-msg'>{error}</Alert>}
      <Form onSubmit={handleSubmit}>
        <div className='list-tech-div'>
        <Form.Group style={{width:'100%'}}>
          <Form.Control
            type="text"
            name="techName"
            value={selectedTechnologies}
            onChange={handleInputTechnologyChange }
            // disabled
            style={{background:'white'}}
          />
        </Form.Group>
        <Button type="submit" className='tech-submit' variant='dark'>Submit</Button>
        </div>
          
        {/* <Form.Group controlId="formExperienceLevel" className='experience-div'>
          <Row>
            {experienceLevels.map((level) => (
              <Col key={level} style={{marginBottom:'5px'}}>
              <label
                className={`experience-label ${experienceLevel === level ? 'selected' : ''}`}
                onClick={() => handleExperienceChange(level)}
              >
                {level}
              </label>
            </Col>
            ))}
          </Row>
        </Form.Group> */}

        <Form.Group controlId="formTechnologies">

          <Container fluid>
            <Row>
              {technologies.map((tech) => (
                <Col md={3} key={tech.name} className="flashcard m-b">
                  <Card className='card-style'>
                    <Card.Img variant="top" src={tech.src} className='img-style' style={{width:'auto'}}/>
                    <Card.Body style={{paddingLeft:'5px',paddingRight:'5px'}}>
                      <Card.Title>{tech.name}</Card.Title>
                      <Card.Text>{tech.short}</Card.Text>
                      {/* <Form.Check
                        type="checkbox"
                        label={`Add ${tech.name}`}
                        name="technologies"
                        value={tech.name}
                        checked={selectedTechnologies.includes(tech.name)}
                        onChange={() => handleTechnologyChange(tech.name)}
                      /> */}
                         <label
                            className={`experience-label ${selectedTechnologies.includes(tech.name) ? 'selected' : ''}`}
                            onClick={() => handleTechnologyChange(tech.name)}
                          >
                            Add {tech.name}
                          </label>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Container>
        </Form.Group>
        {loading && (
                  <div className="spinner-overlay">
                    <Spinner animation="border" role="status">
                      <span className="sr-only"></span>
                    </Spinner>
                  </div>
                )}
        {/* <Button type="submit">Submit</Button> */}
        
      </Form>
      </Container>
    </div>
    </div>
  );
};

export default TechSelect;
